var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Test webpay Return")]),_vm._v("\n"+_vm._s(_vm.resp)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }